window.addEventListener('load', function () {
  var section = document.getElementById('shopify-section-template--21758119772331__page_Bp6Jgz');
  if (!section) return;
  var rte = section.querySelector('.\\#rte');
  if (!rte || rte.dataset.truncated) return;
  rte.dataset.truncated = 'true';

  var fullHeight = rte.scrollHeight;
  var collapsedHeight = Math.round(fullHeight * 0.2);
  rte.style.maxHeight = collapsedHeight + 'px';

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'story-read-more-btn';
  btn.textContent = 'Read Full Story';
  rte.insertAdjacentElement('afterend', btn);

  btn.addEventListener('click', function () {
    rte.style.maxHeight = fullHeight + 'px';
    rte.classList.add('story-expanded');
    btn.remove();
  });
});